module.exports = __webpack_public_path__ + "img/dd.b41cd43c.png";